module.exports = __webpack_public_path__ + "img/dosing-pills.dc445ccb.png";